import { NotificationService } from 'src/app/shared/services/notification.service';
import {
  inject,
  Component,
  ChangeDetectorRef,
  OnInit,
  TemplateRef,
  AfterViewChecked,
  ViewChild
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { defaultFolderDisplayName } from 'src/app/_helpers/default-folder-name';
import { UploaderConfig } from 'src/app/shared/ecpl-document-explorer/uploader-config';
import { ActivatedRoute, Router } from '@angular/router';
import { FeatureManualService } from 'src/app/kuba/feature-documents/feature-document.services';
import { BaseServices } from 'src/app/kuba/kuba.services';
import { environment } from 'src/environments/environment';
import { Location } from '@angular/common';
import * as _ from 'lodash';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ManualService } from 'src/app/kuba/manuals/services/manual.services';
import {
  ParentItem,
  ChildItem,
  FeatureChecklistItemUpdate
} from 'src/app/kuba/feature-documents/feature-document.models';
import { isArray } from 'util';
import { JobAnalysisService } from '../safety-job-analysis/services/jobanalysis.services';

import { ArchiveServices } from '../archive/archive.services';
import { FeatureKey, Rights } from '../../_models';
import { SelectItem } from 'primeng/api';
import { Subscription } from 'rxjs';
import { TreeData } from '../common/models/tree-data.model';

class AppManualList {
  name: string;
  id: number;
  constructor() { }
}
@Component({
  templateUrl: 'feature-document.component.html',
  standalone: false
})
export class FeatureDocumentComponent implements OnInit, AfterViewChecked {
  modalRef: BsModalRef;
  bsConfig = {
    animated: true,
    keyboard: true,
    backdrop: true,
    ignoreBackdropClick: true
  };
  applicationId: number;
  featureId: number;
  featureName: string;
  featureKeyName: string;
  featureKey: number;
  triggerUploader = false;
  portalId: number;
  treeNode: any;
  editMode = false;
  hideButton = true;
  treeActiveNode: any;
  apiResponse = 'none';

  // Document Explorer Configs
  additionalData: any;
  upConfig: UploaderConfig;
  uploadedFiles: any;
  UploadableFile: any;

  featuredocumentId: number;
  additionalFeatures: any;
  pageTitle: string;
  isLar = false;
  filename: string;
  folderToFilter: SelectItem[] = [];
  filteredFolderDetails: any;
  showSavingLoader = false;
  isShowAllFile = false;
  isHideShowAllButton = false;
  loading = false;
  allFiles: any[];
  isFs = false;
  roleId: any;
  userRoleId: any;
  isUpdatingTree = false;
  private subscriptions: Subscription[] = [];
  private readonly notifications = inject(NotificationService);
  @ViewChild('ecplDocumentTree', { static: false }) ecplDocumentTree: any;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private location: Location,
    private featureManualService: FeatureManualService,
    private cdr: ChangeDetectorRef,
    private modalService: BsModalService,
    private manualService: ManualService,
    private archiveServices: ArchiveServices,
    private safetyjobservice: JobAnalysisService,
    private translate: TranslateService
  ) {
    this.featureKeyName = this.route.snapshot.params['manualname'];
    this.applicationId = BaseServices.ApplicationId;
    let workingModule = JSON.parse(sessionStorage.getItem('workingModule'));
    this.featureName = workingModule.name;
    this.featureId = workingModule.id;
    this.featureKey = route.snapshot.parent.params['id'];
    // Match the resolver's business scope even when session state is still changing.
    if (this.featureId === FeatureKey.FLEXI) {
      const routedBusinessId = Number(route.snapshot.pathFromRoot.find(
        parent => parent.routeConfig?.path === 'business/:id'
      )?.paramMap.get('id'));
      this.featureKey = routedBusinessId > 0 ? routedBusinessId : BaseServices.BusinessId;
    }
    this.treeNode = this.route.snapshot.data['list'];

    if (this.featureId == 20 || this.featureId == 43) {
      this.isFs = true;
    }
    if (+BaseServices.roleId === 4) {
      this.hideButton = false;
    } else if (+BaseServices.roleId === 5) {
      if (this.featureId == FeatureKey.PROJECT) {
        this.hideButton = this.isUserRights(Rights.ADMINISTRATE_PROJECTS);
      } else if (this.featureId == FeatureKey.FDV) {
        this.hideButton = this.isUserRights(Rights.ADMINISTRATE_FDV);
      } else if (this.featureId == FeatureKey.INTERNAL_CONTROL) {
        this.hideButton = this.isUserRights(
          Rights.ADMINISTRATE_INTERNAL_CONTROL
        );
      } else if (this.featureId == FeatureKey.OTHER_SYSTEMS) {
        this.hideButton = this.isUserRights(Rights.ADMINISTRATE_OTHER_SYSTEMS);
      } else if (this.featureId == FeatureKey.QUALITY_SYSTEMS) {
        this.hideButton = this.isUserRights(Rights.ADMINISTRATE_QUALITY_SYSTEM);
      } else if (this.featureId == FeatureKey.KUNDE_EL) {
        this.hideButton = this.isUserRights(Rights.IK_KUNDE_EL_RIGHTS);
      } else if (this.featureId == FeatureKey.FRAMEWORK_AGREEMENT) {
        this.hideButton = this.isUserRights(Rights.FRAMEWORK_AGREEMENT_RIGHTS);
      } else if (this.featureId == FeatureKey.SERVICE_AGREEMENT) {
        this.hideButton = this.isUserRights(Rights.SERVICE_AGREEMENT_RIGHTS);
      } else if (this.featureId == FeatureKey.FOOD_SAFETY) {
        this.hideButton = this.isUserRights(Rights.ADMINISTRATE_FOOD_SAFETY);
      } else if (this.featureId == FeatureKey.FLEXI) {
        this.hideButton = this.isUserRights(Rights.ADMINISTRATE_FLEXI);
      } else if (this.featureId == FeatureKey.KUBA_CONTROL) {
        this.hideButton = this.isUserRights(Rights.ADMINISTRATE_KUBA_CONTROL);
      } else if (this.featureId == FeatureKey.VEHICLES) {
        this.hideButton = true;
      } else {
        this.hideButton = false;
      }
    } else {
      this.hideButton = true;
    }

    if (+BaseServices.roleId === 3) {
      if (this.featureId == FeatureKey.FLEXI) {
        this.hideButton = false;
      } else {
        this.hideButton = true;
      }
    }

    if (+BaseServices.roleId === 3) {
      if (this.featureId == FeatureKey.FLEXI) {
        this.hideButton = false;
      } else {
        this.hideButton = true;
      }
    }

    if (window.name === 'Remote') {
      let businessId = +sessionStorage.getItem('RModeBusinessId');
      this.userRoleId = Number(BaseServices.AbsoluteroleId);

      if (businessId > 0 && this.featureId == FeatureKey.FLEXI) {
        this.hideButton = this.userRoleId === 1;
      }
    }

    this.upConfig = {
      title: 'ALL_FILES',
      viewSwitch: false,
      editMode: this.editMode,
      windowedHeight: true,
      showUserMeta: true,
      uploaderUri: environment.BASE_URL + '/file/upload/business/manual',
      addtionalData: null,
      showDownloadAll: true,
      showFoodSafetyFiler:
        this.featureId === FeatureKey.FOOD_SAFETY ? true : false,
      showDeleteAllButton: true,
      documentType: 'allFiles'
    };
    if (BaseServices.UserRole === 'Admin' && BaseServices.BusinessId === 0) {
      this.subscriptions.push(
        this.featureManualService
          .getAdminProjectFeatureKey(this.featureKey)
          .subscribe((result: any) => {
            if (result) {
              this.featureKey = result;
            }
          })
      );
    }

    this.subscriptions.push(
      this.translate.stream('DEFAULT_FOLDER').subscribe(val => {
        if (this.filteredFolderDetails) {
          let filteredFolder = this.filteredFolderDetails.filter(
            x => x.isFolder === true
          );
          if (filteredFolder) {
            this.folderToFilter = [];
            this.folderToFilter.push({ label: val.SELECT, value: null });
            filteredFolder.forEach(element => {
              this.folderToFilter.push({
                label: defaultFolderDisplayName(element, this.translate),
                value: element.nodeId
              });
            });
          }
        }
      })
    );
  }

  // Events form Tree
  catchEvent(event): void {
    this.triggerUploader = false;
    switch (event.eventName) {
      case 'CheckBoxStatus':
        this.isUpdatingTree = true;
        this.subscriptions.push(
          this.featureManualService
            .updateManualCheckboxstatus(
              event.node.data,
              this.featureId,
              this.featureKey
            )
            .subscribe(
              response => {
                this.refreshTreeNode();
              },
              error => console.log('Checkbox status not update : ', error),
              () => console.log('Checkbox status updated')
            )
        );
        break;

      case 'AddNewRootFolder':
        this.isUpdatingTree = true;
        let tempEvent = event;
        if (tempEvent.parent) {
          tempEvent.parent.nodeId = 0;
        }
        this.subscriptions.push(
          this.featureManualService
            .createFeatureManualFolder(this.featureKey, tempEvent)
            .subscribe(
              response => {
                this.notifications.success('UI_NOTIFICATIONS.SAVED');
                this.refreshTreeNode();
              },
              error => {
                console.log('Manual Create folder Error : ', error);
                this.isUpdatingTree = false;
              },
              () => console.log('Manual Create folder Complete')
            )
        );
        break;
      case 'AddNewFolder':
        this.isUpdatingTree = true;
        this.subscriptions.push(
          this.featureManualService
            .createFeatureManualFolder(this.featureKey, event)
            .subscribe(
              response => {
                this.notifications.success('UI_NOTIFICATIONS.SAVED');
                this.refreshTreeNode();
              },
              error => {
                console.log('Manual Create folder Error : ', error);
                this.isUpdatingTree = false;
              },
              () => console.log('Manual Create folder Complete')
            )
        );
        break;

      case 'RenameFolder':
        this.isUpdatingTree = true;
        this.subscriptions.push(
          this.featureManualService
            .renameFeatureManualFolder(this.featureKey, event)
            .subscribe(
              response => {
                this.refreshTreeNode();
              },
              error => {
                console.log('Manual Rename folder Error : ', error);
                this.isUpdatingTree = false;
              },
              () => console.log('Manual Rename folder Complete')
            )
        );
        break;

      case 'DeleteFolder':
        this.isUpdatingTree = true;
        this.subscriptions.push(
          this.featureManualService
            .deleteFeatureManualFolder(this.featureKey, event.item.data.nodeId)
            .subscribe(
              response => {
                this.refreshTreeNode();
                this.notifications.success('UI_NOTIFICATIONS.DELETED');
              },
              error => {
                console.log('Manual delete folder Error : ', error);
                this.isUpdatingTree = false;
              },
              () => console.log('Manual delete folder Complete')
            )
        );
        break;

      case 'AddFiles':
        this.triggerUploader = true;

        break;
      case 'EditFile':
        // TODO:

        break;
      case 'RenameFile':
        this.isUpdatingTree = true;
        this.subscriptions.push(
          this.featureManualService
            .renameDocument(this.featureKey, event)
            .subscribe(
              response => {
                this.refreshTreeNode();
              },
              error => {
                console.log('Rename file error : ', error);
                this.isUpdatingTree = false;
              },
              () => console.log('Rename file Complete')
            )
        );
        break;

      case 'DeleteDefaultFile':
        this.isUpdatingTree = true;
        this.subscriptions.push(
          this.safetyjobservice
            .deleteCompleteCheckListData(event.item.data.nodeId)
            .subscribe(
              response => {
                this.refreshTreeNode();
                this.notifications.success('UI_NOTIFICATIONS.DELETED');
              },
              error => {
                console.log('Delete file error : ', error);
                this.isUpdatingTree = false;
              },
              () => console.log('delete future checklist undercom')
            )
        );
        break;
      case 'DeleteFile':
        this.isUpdatingTree = true;
        this.subscriptions.push(
          this.featureManualService
            .deleteDocument(this.featureKey, event.item.data.nodeId)
            .subscribe(
              response => {
                this.refreshTreeNode();
                this.notifications.success('UI_NOTIFICATIONS.DELETED');
              },
              error => {
                console.log('Manual file delete Error : ', error);
                this.isUpdatingTree = false;
              },
              () => console.log('Manual file delete Complete')
            )
        );
        break;
      case 'DeleteFSundercompletionFile':
        this.isUpdatingTree = true;
        this.subscriptions.push(
          this.archiveServices
            .deleteFoodSafety(event.item.data.nodeId)
            .subscribe(
              response => {
                this.refreshTreeNode();
                this.notifications.success('UI_NOTIFICATIONS.DELETED');
              },
              error => {
                console.log('Manual delete FS file Error : ', error);
                this.isUpdatingTree = false;
              },
              () => console.log('Manual delete FS file Complete')
            )
        );
        break;
      case 'NewArticle':
        // TODO:
        this.isUpdatingTree = true;
        let aVersion = event.item.articleContent.article.version;
        this.subscriptions.push(
          this.featureManualService
            .newArticle(this.featureKey, event)
            .subscribe(
              (response: any) => {
                this.subscriptions.push(
                  this.featureManualService
                    .newArticleText(
                      this.featureKey,
                      response.Id,
                      event,
                      true,
                      aVersion
                    )
                    .subscribe(result => {
                      this.refreshTreeNode();
                      this.notifications.success('UI_NOTIFICATIONS.SAVED');
                    })
                );
              },
              error => {
                console.log('New article error : ', error);
                this.isUpdatingTree = false;
              },
              () => console.log('new article Complete')
            )
        );
        break;
      case 'SaveArticle':
        // TODO:
        this.isUpdatingTree = true;
        let version = event.item.articleContent.article.version;
        this.subscriptions.push(
          this.featureManualService
            .saveArticle(this.featureKey, event)
            .subscribe(
              (response: any) => {
                this.subscriptions.push(
                  this.featureManualService
                    .newArticleText(
                      this.featureKey,
                      response.Id,
                      event,
                      false,
                      version
                    )
                    .subscribe(result => {
                      this.refreshTreeNode();
                      this.notifications.success('UI_NOTIFICATIONS.SAVED');
                    })
                );
              },
              error => {
                console.log('Save article error : ', error);
                this.isUpdatingTree = false;
              },
              () => console.log('save article Complete')
            )
        );
        break;
      case 'RenameArticle':
        this.isUpdatingTree = true;
        this.subscriptions.push(
          this.featureManualService
            .renameArticle(this.featureKey, event)
            .subscribe(
              response => {
                this.refreshTreeNode();
              },
              error => {
                console.log('Rename article error : ', error);
                this.isUpdatingTree = false;
              },
              () => console.log('Rename article Complete')
            )
        );
        break;
      case 'DeleteArticle':
        this.isUpdatingTree = true;
        this.subscriptions.push(
          this.featureManualService
            .deleteArticle(this.featureKey, event.item.data.nodeId)
            .subscribe(
              response => {
                this.refreshTreeNode();
                this.notifications.success('UI_NOTIFICATIONS.DELETED');
              },
              error => {
                console.log('Manual article delete Error : ', error);
                this.isUpdatingTree = false;
              },
              () => console.log('Manual article delete Complete')
            )
        );
        break;
      case 'DeleteSelectedArticle':
        this.isUpdatingTree = true;
        this.subscriptions.push(
          this.featureManualService
            .deleteMultipleArticle(event.item.data)
            .subscribe(
              response => {
                this.refreshTreeNode();
                this.notifications.success('UI_NOTIFICATIONS.DELETED');
              },
              error => {
                console.log('Manual delete articles Error : ', error);
                this.isUpdatingTree = false;
              },
              () => console.log('Manual delete articles Complete')
            )
        );
        break;
      case 'DeleteSelectedChecklist':
        this.isUpdatingTree = true;
        const checklistIds = this.extractNodeIds(event.item.data);
        this.subscriptions.push(
          this.featureManualService
            .deleteMultipleChecklist(checklistIds)
            .subscribe(
              response => {
                this.refreshTreeNode();
                this.notifications.success('UI_NOTIFICATIONS.DELETED');
              },
              error => {
                console.log('Manual delete checklists Error : ', error);
                this.isUpdatingTree = false;
              },
              () => console.log('Manual delete checklists Complete')
            )
        );
        break;
      case 'DeleteSelectedDocuments':
        this.isUpdatingTree = true;
        var documentIds = this.extractNodeIds(event.item.data);
        this.subscriptions.push(
          this.featureManualService
            .deleteMultipleDocument(documentIds)
            .subscribe(
              response => {
                this.refreshTreeNode();
                this.notifications.success('UI_NOTIFICATIONS.DELETED');
              },
              error => {
                console.log('Manual delete documents Error : ', error);
                this.isUpdatingTree = false;
              },
              () => console.log('Manual delete documents Complete')
            )
        );
        break;
      case 'DeleteSelectedUnderCompletionChecklist':
        this.isUpdatingTree = true;
        this.subscriptions.push(
          this.safetyjobservice
            .deleteMultipleCompleteChecklist(event.item.data)
            .subscribe(
              response => {
                this.refreshTreeNode();
                this.notifications.success('UI_NOTIFICATIONS.DELETED');
              },
              error => {
                console.log('Manual delete under completion Error : ', error);
                this.isUpdatingTree = false;
              },
              () => console.log('Manual delete under completion Complete')
            )
        );
        break;
      case 'DeleteSelectedFSUnderCompletionChecklist':
        this.isUpdatingTree = true;
        const underCompleteChecklistIds = this.extractNodeIds(event.item.data);
        this.subscriptions.push(
          this.archiveServices
            .deleteMultipleFoodSafety(underCompleteChecklistIds)
            .subscribe(
              response => {
                this.refreshTreeNode();
                this.notifications.success('UI_NOTIFICATIONS.DELETED');
              },
              error => {
                console.log('Manual delete FS under completion Error : ', error);
                this.isUpdatingTree = false;
              },
              () => console.log('Manual delete FS under completion Complete')
            )
        );
        break;
      case 'DeleteAllFiles': //KW-912
        let eventDataList = event.item.data;
        let totalEventCount = eventDataList.length;
        let eventList = [];
        eventDataList.forEach(element => {
          let data = {};
          switch (element.eventName) {
            case 'DeleteSelectedArticle':
              data = {
                functionCalled:
                  this.featureManualService.deleteMultipleArticle.bind(
                    this.featureManualService
                  ),
                dataList: element.item.data
              };
              eventList.push(data);
              break;
            case 'DeleteSelectedChecklist':
              data = {
                functionCalled:
                  this.featureManualService.deleteMultipleChecklist.bind(
                    this.featureManualService
                  ),
                dataList: element.item.data
              };
              eventList.push(data);
              break;
            case 'DeleteSelectedDocuments':
              data = {
                functionCalled:
                  this.featureManualService.deleteMultipleDocument.bind(
                    this.featureManualService
                  ),
                dataList: this.extractNodeIds(element.item.data)
              };
              eventList.push(data);
              break;
            case 'DeleteSelectedUnderCompletionChecklist':
              data = {
                functionCalled:
                  this.safetyjobservice.deleteMultipleCompleteChecklist.bind(
                    this.safetyjobservice
                  ),
                dataList: element.item.data
              };
              eventList.push(data);
              break;
            case 'DeleteSelectedFSUnderCompletionChecklist':
              const underCompleteChecklistIds = this.extractNodeIds(event.item.data[0].item.data);
              data = {
                functionCalled: () => this.archiveServices.deleteMultipleFoodSafety(underCompleteChecklistIds),
                dataList: element.item.data
              };
              eventList.push(data);
              break;
          }
        });
        let count = 0;
        eventList.forEach(element => {
          let functionCalled = element.functionCalled;
          let data = element.dataList;
          this.subscriptions.push(
            functionCalled(data).subscribe(
              response => {
                count++;
                if (count == totalEventCount) {
                  this.refreshTreeNode();
                  this.notifications.success('UI_NOTIFICATIONS.DELETED');
                }
              },
              error => console.log('Delete Error', error),
              () => console.log('Delete Complete')
            )
          );
        });

        break;
      case 'NewChecklist':
        // TODO:
        this.isUpdatingTree = true;
        this.subscriptions.push(
          this.featureManualService
            .createChecklist(this.featureId, this.featureKey, event)
            .subscribe(
              (response: any) => {
                let checklistId = response.Id;
                event.item.checkList.id = checklistId;
                let listModel = this.checklistSaveObj(event, 0);
                this.subscriptions.push(
                  this.featureManualService
                    .saveChecklist(checklistId, listModel)
                    .subscribe(
                      response => {
                        event.onSaved?.(true);
                        this.notifications.success('UI_NOTIFICATIONS.SAVED');
                        this.refreshTreeNode();
                      },
                      error => {
                event.onSaved?.(false);
                        console.log('Save checklistitem error : ', error);
                        this.isUpdatingTree = false;
                      },
                      () => console.log('save checklistitem Complete')
                    )
                );
              },
              error => {
                event.onSaved?.(false);
                console.log('Create checklist error : ', error);
                this.isUpdatingTree = false;
              },
              () => console.log('create checklist Complete')
            )
        );
        break;
      case 'SaveChecklist':
        // TODO:
        this.isUpdatingTree = true;
        let tempchecklistId = event.item.checkList.id;
        let templistModel = this.checklistSaveObj(event, BaseServices.UserId);
        this.subscriptions.push(
          this.featureManualService
            .saveChecklist(tempchecklistId, templistModel)
            .subscribe(
              response => {
                event.onSaved?.(true);
                        this.notifications.success('UI_NOTIFICATIONS.SAVED');
                this.refreshTreeNode();
              },
              error => {
                event.onSaved?.(false);
                console.log('Save checklistitem error : ', error);
                this.isUpdatingTree = false;
              },
              () => console.log('save checklistitem Complete')
            )
        );
        break;
      case 'EditChecklist':
        // TODO:
        this.isUpdatingTree = true;
        let checklistId = event.item.checkList.id;
        let listModel = this.checklistSaveObj(event, BaseServices.UserId);

        this.subscriptions.push(
          this.featureManualService
            .saveChecklist(checklistId, listModel)
            .subscribe(
              response => {
                this.notifications.success('UI_NOTIFICATIONS.SAVED');
                this.refreshTreeNode();
              },
              error => {
                console.log('Save checklist error : ', error);
                this.isUpdatingTree = false;
              },
              () => console.log('save checklist Complete')
            )
        );

        break;
      case 'RenameChecklist':
        this.isUpdatingTree = true;
        this.subscriptions.push(
          this.featureManualService
            .renameChecklist(this.featureKey, event)
            .subscribe(
              response => {
                this.refreshTreeNode();
              },
              error => {
                console.log('Rename checklist error : ', error);
                this.isUpdatingTree = false;
              },
              () => console.log('Rename checklist Complete')
            )
        );
        break;
      case 'DeleteChecklist':
        this.isUpdatingTree = true;
        this.subscriptions.push(
          this.featureManualService
            .deleteChecklist(this.featureKey, event.item.data.nodeId)
            .subscribe(
              response => {
                this.refreshTreeNode();
                this.notifications.success('UI_NOTIFICATIONS.DELETED');
              },
              error => {
                console.log('Manual checklist delete Error : ', error);
                this.isUpdatingTree = false;
              },
              () => console.log('Manual checklist delete Complete')
            )
        );
        break;
      case 'moveNode':
        this.isUpdatingTree = true;
        this.subscriptions.push(
          this.featureManualService.moveFeatureNode(event).subscribe(
            response => {
              if (response) {
                this.refreshTreeNode();
              } else {
                this.isUpdatingTree = false;
              }
            },
            error => {
              console.log('Manual movenode Error : ', error);
              this.isUpdatingTree = false;
            },
            () => console.log('Manual movenode Complete')
          )
        );
        break;
      case 'NewLar':
        this.isUpdatingTree = true;
        this.subscriptions.push(
          this.featureManualService
            .CreateLar(this.featureId, this.featureKey, event)
            .subscribe(
              response => {
                this.refreshTreeNode();
              },
              error => {
                this.apiResponse = 'failed';
                this.isUpdatingTree = false;
                console.log('new lar error : ', error);
              },
              () => console.log('new lar Complete')
            )
        );
        break;
      case 'SaveLar':
        this.isUpdatingTree = true;
        this.subscriptions.push(
          this.featureManualService.saveLar(event).subscribe(
            response => {
              this.notifications.success('UI_NOTIFICATIONS.SAVED');
              this.refreshTreeNode();
            },
            error => {
              this.apiResponse = 'failed';
              this.isUpdatingTree = false;
              console.log('Save lar error : ', error);
            },
            () => console.log('save lar Complete')
          )
        );
        break;
      case 'DeleteLar':
        this.isUpdatingTree = true;
        this.subscriptions.push(
          this.featureManualService.deleteLar(event.item.larId).subscribe(
            response => {
              this.refreshTreeNode();
              this.notifications.success('UI_NOTIFICATIONS.DELETED');
            },
            error => {
              console.log('Lar delete Error : ', error);
              this.isUpdatingTree = false;
            },
            () => console.log('Lar delete Complete')
          )
        );
        break;
      case 'activate':
        this.isShowAllFile = true;
        if (event.node && event.node.data) {
          const docType = event.node.data.documentType;

          if (docType === 'laws' || docType === 'regulation') {
            this.isLar = true;
            this.uploadedFiles = event.node.data.content || [];
            this.filename = docType;
            this.upConfig.title = event.node.data.filename || this.upConfig.title;
            this.treeActiveNode = event.node;
          } else {
            this.isLar = false;
            this.uploadedFiles = Array.isArray(event.node.data.nodes) ? event.node.data.nodes : [];
            if (event.node.data.nodes) {
              let filteredFolder = event.node.data.nodes.filter(
                x => x.isFolder === true
              );
              this.filteredFolderDetails = event.node.data.nodes;
              if (filteredFolder) {
                this.folderToFilter = [];
                this.folderToFilter.push({
                  label: this.translate.instant('SELECT'),
                  value: null
                });
                filteredFolder.forEach(element => {
                  this.folderToFilter.push({
                    label: defaultFolderDisplayName(element, this.translate),
                    value: element.nodeId
                  });
                });
              }
            }
            this.upConfig.title = event.node.data.filename || this.upConfig.title;
            this.upConfig.documentType = docType;
            this.upConfig.addtionalData = {
              ApplicationId: BaseServices.ApplicationId,
              BusinessId: BaseServices.BusinessId,
              FolderPath:
                'fid-' +
                this.featureKey +
                '-' +
                this.featureName.replace(' ', '-').toLowerCase(),
              FolderTypeNafeatureNameme: docType,
              FeatureId: this.featureId,
              FeatureKey: +this.featureKey,
              FeatureName: this.featureName,
              FeatureFolderId: event.node.data.nodeId,
              userId: BaseServices.UserId
            };

            this.treeActiveNode = event.node;
          }
        } else {
          // No node data: ensure explorer shows empty list
          this.uploadedFiles = [];
          this.treeActiveNode = event.node || null;
        }

        this.cdr.detectChanges();
        break;
      case 'deactivate':
        if (event.node && event.node.data && event.node.data.nodes) {
          let filteredFolder = event.node.data.nodes.filter(
            x => x.isFolder === true
          );
          this.filteredFolderDetails = event.node.data.nodes;
          if (filteredFolder) {
            this.folderToFilter = [];
            this.folderToFilter.push({
              label: this.translate.instant('SELECT'),
              value: null
            });
            filteredFolder.forEach(element => {
              this.folderToFilter.push({
                label: defaultFolderDisplayName(element, this.translate),
                value: element.nodeId
              });
            });
          }
        }
        break;
      case 'CopyFile':
        if (
          confirm(
            'You are about to creating a new copy of this file, Do you really want to proceed?'
          )
        ) {
          // Service that copy existing file to respective place
          this.subscriptions.push(
            this.manualService.createCopyofDocument(event).subscribe(
              (response: any) => {
                let docPathDto = {
                  Id: event.item.data.nodeId,
                  Path: response.path,
                  ModifiedBy: BaseServices.UserId
                };
                this.subscriptions.push(
                  this.featureManualService
                    .copyFeatureManualDocument(docPathDto)
                    .subscribe(
                      (result: any) => {
                        this.refreshTreeNode();
                        this.notifications.success('UI_NOTIFICATIONS.SAVED');
                      },
                      (error: any) => {
                        console.error('Manual document service error:', error);
                      },
                      () => {
                        console.log('Adding manual document service complete.');
                      }
                    )
                );
              },
              error => console.error('Document version  Error : ', error),
              () => console.log('Document version  Complete')
            )
          );
          // service that update existing record in document based on Module
        }
        break;
      case 'CopyEditVersionDocument':
        // Service that copy existing file to respective place
        this.subscriptions.push(
          this.manualService.createEditCopyofDocument(event).subscribe(
            (response: any) => {
              let docPathDto = {
                Id: event.item.id,
                Path: response.path,
                ModifiedBy: BaseServices.UserId
              };
            },
            error => console.error('Document version  Error : ', error),
            () => console.log('Document version  Complete')
          )
        );
        break;
      case 'initialized':
        break;
      case 'updateData':
        break;
      case 'loadNodeChildren':
        break;
      case 'ShowOfficeFileSaveloader':
        if (parseInt(sessionStorage.getItem('isDocumentChanged'), null)) {
          this.subscriptions.push(
            this.featureManualService
              .UpdateDocument(event.item.data.nodeId, BaseServices.UserId)
              .subscribe(response => { })
          );
          this.showSavingLoader = true;
          setTimeout(() => {
            this.refreshTreeNode();
            this.showSavingLoader = false;
          }, 15000);
          sessionStorage.setItem('isDocumentChanged', '0');
        }
        break;
      default:
        if (event.node && event.node.data && event.node.data.documentType === 'undercompletion') {
          this.router.navigate(
            [
              '../../../../../complete-checklist/incomplete/' +
              event.node.data.nodeId,
              'feature',
              0,
              0
            ],
            { relativeTo: this.route }
          );
        } else if (event.node && event.node.data && event.node.data.documentType === 'manualfsundercompletion') {
          this.router.navigate(
            [
              '../../../../../fs-complete-checklist/incomplete/' +
              event.node.data.nodeId
            ],
            { relativeTo: this.route }
          );
        } else if (
          event.node && event.node.data &&
          event.node.data.documentType === 'vehiclecontrolundercompletion'
        ) {
          this.router.navigate(
            [
              '../../../../../vehicle-complete-checklist/incomplete/' +
              event.node.data.nodeId
            ],
            { relativeTo: this.route }
          );
        }
        break;
    }
  }

  // emitter for save from Document Explorer
  saveUploaded(event: any) {
    let fileExtension = '';
    if (event.mimetype) {
      const parts = event.mimetype.split('/');
      if (parts.length > 1) {
        fileExtension = parts[1];
        event.mimetype = fileExtension;
      }
    }
    switch (event.eventName) {
      case 'NewArticle':
        if (
          this.treeActiveNode &&
          this.treeActiveNode.data &&
          this.treeActiveNode.data.nodeId
        ) {
          event.activeNodeId = this.treeActiveNode.data.nodeId;
        } else {
          event.activeNodeId = this.treeActiveNode[0].nodeId;
        }
        this.catchEvent(event);
        break;
      case 'AddNewFolder':
        if (!event.parent && this.treeActiveNode) {
          event.parent = this.treeActiveNode.data;
        }
        this.catchEvent(event);
        break;
      case 'DeleteFolder':
      case 'DeleteArticle':
      case 'DeleteChecklist':
      case 'DeleteDefaultFile':
      case 'DeleteFile':
      case 'DeleteFSundercompletionFile':
      case 'DeleteSelectedArticle':
      case 'DeleteSelectedChecklist':
      case 'DeleteSelectedDocuments':
      case 'DeleteSelectedUnderCompletionChecklist':
      case 'DeleteSelectedFSUnderCompletionChecklist':
      case 'DeleteAllFiles':
        this.catchEvent(event);
        break;
      case 'SaveArticle':
        if (this.treeActiveNode && this.treeActiveNode.data) {
          event.activeNodeId = this.treeActiveNode.data.nodeId;
        }
        this.catchEvent(event);
        break;
      case 'NewChecklist':
      case 'SaveChecklist':
      case 'EditChecklist':
        if (this.treeActiveNode && this.treeActiveNode.data) {
          event.activeNodeId = this.treeActiveNode.data.nodeId;
        } else {
          event.activeNodeId = 3; // Online Checklist - TODO: Refactor this logic and remove side effects events
        }
        this.catchEvent(event);
        break;
      case 'NewLar':
      case 'SaveLar':
      case 'DeleteLar':
        if (this.treeActiveNode && this.treeActiveNode.data) {
          event.activeNodeId = this.treeActiveNode.data.nodeId;
        }
        this.catchEvent(event);
        break;
      case 'SaveArticle':
        if (this.treeActiveNode !== undefined) {
          event.activeNodeId = this.treeActiveNode.data.nodeId;
        }
        this.catchEvent(event);
        break;
      case 'CopyEditVersionDocument':
        if (this.treeActiveNode && this.treeActiveNode.data) {
          event.activeNodeId = this.treeActiveNode.data.nodeId;
        }
        this.catchEvent(event);
        break;
      case 'ShowOfficeFileSaveloader':
        if (parseInt(sessionStorage.getItem('isDocumentChanged'), null)) {
          this.showSavingLoader = true;
          this.subscriptions.push(
            this.featureManualService
              .UpdateDocument(event.item.id, BaseServices.UserId)
              .subscribe(response => {
                if (response) {
                  console.log(response);
                }
              })
          );
          setTimeout(() => {
            this.refreshTreeNode();
            this.showSavingLoader = false;
          }, 15000);
          sessionStorage.setItem('isDocumentChanged', '0');
        }
        break;
      default:
        let uploadedFile = Object.assign(
          {},
          event,
          this.upConfig.addtionalData
        );
        this.subscriptions.push(
          this.featureManualService
            .addFeatureManualDocument(uploadedFile)
            .subscribe(
              (result: any) => {
                this.notifications.success('UI_NOTIFICATIONS.SAVED');
                this.refreshTreeNode();
              },
              (error: any) => {
                console.error('Manual document service error:', error);
              },
              () => { }
            )
        );
        break;
    }
  }

  // Emitter for selected folder from Document Explorer
  setActiveNodeIntree(event: any) {
    this.filteredFolderDetails = event;
    let filteredFiles = event[0].nodes.filter(x => x.isFolder === true);
    this.filteredFolderDetails = event[0].nodes;
    if (filteredFiles) {
      this.folderToFilter = [];
      this.folderToFilter.push({
        label: this.translate.instant('SELECT'),
        value: null
      });
      filteredFiles.forEach(element => {
        this.folderToFilter.push({
          label: defaultFolderDisplayName(element, this.translate),
          value: element.nodeId
        });
      });
    }
    this.treeActiveNode = event;
    if (this.treeActiveNode && this.treeActiveNode[0] && this.upConfig.addtionalData) {
      this.upConfig.addtionalData.FeatureFolderId = this.treeActiveNode[0].nodeId;
    }
  }

  pushToBack() {
    if (this.featureId === FeatureKey.FOOD_SAFETY) {
      this.router.navigate(['../../../../list/all', { fs: '1' }], {
        relativeTo: this.route
      });
    } else {
      this.location.back();
    }
  }

  // Toggle Edit Mode
  toggleEditMode() {
    this.editMode = !this.editMode;
    this.upConfig.editMode = !this.upConfig.editMode;
  }

  refreshTreeNode() {
    this.subscriptions.push(
      this.featureManualService.getFeatureManualTree(this.featureKey).subscribe(
        (result: any) => {
          // Merge into existing tree if we have one, otherwise set directly
          if (
            this.ecplDocumentTree &&
            this.ecplDocumentTree.primeNodes &&
            this.ecplDocumentTree.primeNodes.length > 0
          ) {
            // Merge new data into existing nodes to preserve UI state
            this.mergeTreeData(this.ecplDocumentTree.primeNodes, result);
            // Also update treeNode reference for data binding
            this.treeNode = result;
          } else {
            this.treeNode = result;
          }

          if (this.upConfig.title !== 'ALL_FILES') {
            let flattenned = this.flattenArrObj(this.treeNode);
            if (this.treeActiveNode) {
              if (this.treeActiveNode.data && this.treeActiveNode.data.id) {
                const parent = _.filter(flattenned, [
                  'id',
                  this.treeActiveNode.data.id
                ]);
                if (parent && parent[0]) {
                  this.uploadedFiles = parent[0].nodes;
                  this.upConfig.title = parent[0].filename;
                  if (this.upConfig.addtionalData) {
                    this.upConfig.addtionalData.FeatureFolderId = parent[0].nodeId;
                  }
                }
              } else if (this.treeActiveNode[0]) {
                const parent = _.filter(flattenned, [
                  'id',
                  this.treeActiveNode[0].id
                ]);
                if (parent && parent[0]) {
                  this.uploadedFiles = parent[0].nodes;
                  this.upConfig.title = parent[0].filename;
                  if (this.upConfig.addtionalData) {
                    this.upConfig.addtionalData.FeatureFolderId = parent[0].nodeId;
                  }
                }
              }
            }
          } else {
            this.ngOnInit();
          }
        },
        (error: any) => {
          console.error('Api Error while refreshing tree:', error);
          this.loading = false;
          this.isUpdatingTree = false;
        },
        () => {
          this.apiResponse = 'reloaded';
          this.loading = false;
          this.isUpdatingTree = false;
        }
      )
    );
  }

  /**
   * Merge new tree data into existing prime nodes without rebuilding
   * Trust server data for structure and content, preserve only UI state (expanded)
   */
  private mergeTreeData(primeNodes: any[], sourceData: any[]): void {
    if (!primeNodes || !sourceData) return;

    // Step 1: Capture expansion state from ALL existing nodes (flat map by ID)
    const expansionState = new Map<number, boolean>();
    const captureExpansion = (nodes: any[]) => {
      if (!nodes) return;
      nodes.forEach(node => {
        if (node.data && node.data.nodeId !== undefined) {
          expansionState.set(node.data.nodeId, !!node.expanded);
        }
        if (node.children && node.children.length > 0) {
          captureExpansion(node.children);
        }
      });
    };
    captureExpansion(primeNodes);

    // Helper to filter out status=2 nodes (hidden) - used in view mode
    const filterByStatus = (nodes: any[]): any[] => {
      if (!nodes || !Array.isArray(nodes)) return [];
      return nodes.filter(node => node.status !== 2).map(node => ({
        ...node,
        nodes: node.nodes ? filterByStatus(node.nodes) : []
      }));
    };

    // Apply status filtering in view mode (not edit mode)
    const dataToRebuild = this.editMode ? sourceData : filterByStatus(sourceData);

    // Step 2: Rebuild tree from server data, restoring expansion state
    const rebuildNodes = (sourceNodesList: any[], depth: number = 0): any[] => {
      if (!sourceNodesList || !Array.isArray(sourceNodesList)) return [];

      return sourceNodesList.map(sourceNode => {
        const nodeId = sourceNode.nodeId;
        const wasExpanded = expansionState.get(nodeId) || false;

        // Create fresh node from server data
        const newNode: any = {
          data: { ...sourceNode, _depth: depth, nodes: sourceNode.nodes || [] },
          label: sourceNode.filename,
          expanded: wasExpanded || !!sourceNode.expanded,
          selectable: true,
          children: []
        };

        // Recursively rebuild children
        if (Array.isArray(sourceNode.nodes) && sourceNode.nodes.length > 0) {
          newNode.children = rebuildNodes(sourceNode.nodes, depth + 1);
          newNode.children.forEach((child: any) => {
            child.parent = newNode;
          });
        }

        newNode.hasChildren = newNode.children.length > 0;
        newNode.data.hasChildren = newNode.hasChildren;
        (newNode as any).nodes = newNode.children;

        // Add compatibility methods
        newNode.setIsSelected = (selected: boolean) => {
          newNode.selected = !!selected;
          if (newNode.data) newNode.data.selected = !!selected;
        };
        newNode.expand = () => { newNode.expanded = true; };
        newNode.collapse = () => { newNode.expanded = false; };

        return newNode;
      }).filter(n => n !== null);
    };

    // Step 3: Replace primeNodes content with rebuilt nodes
    const newNodes = rebuildNodes(dataToRebuild, 0);
    primeNodes.splice(0, primeNodes.length, ...newNodes);
  }

  refresh(event) {
    this.loading = true;
    this.isUpdatingTree = true;
    this.refreshTreeNode();
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, this.bsConfig);
  }

  ngAfterViewChecked() {
    this.cdr.detectChanges();
  }

  onFilteredFolder(value: any) {
    if (this.filteredFolderDetails) {
      let filteredFiles =
        value == null
          ? this.filteredFolderDetails
          : this.filteredFolderDetails.filter(x => x.nodeId === value);
      this.uploadedFiles =
        value == null
          ? this.flattenArrObj(filteredFiles)
          : filteredFiles[0].nodes;
      filteredFiles = this.uploadedFiles.filter(x => x.isFolder === true);
      if (this.treeActiveNode) {
        this.filteredFolderDetails = filteredFiles;
        if (filteredFiles) {
          this.folderToFilter = [];
          this.folderToFilter.push({
            label: this.translate.instant('SELECT'),
            value: null
          });
          filteredFiles.forEach(element => {
            this.folderToFilter.push({
              label: defaultFolderDisplayName(element, this.translate),
              value: element.nodeId
            });
          });
        }
      }
    }
  }

  ngOnInit() {
    document.querySelector('body').classList.remove('opened');
    this.upConfig.title = 'ALL_FILES';
    this.upConfig.documentType = 'allFiles';
    this.showAllFiles();
  }

  // private
  private flattenArrObj(arr) {
    let newArr = [];
    if (Array.isArray(arr) && arr.length > 0) {
      arr.forEach(element => {
        newArr.push(element);
        if (Array.isArray(element.nodes) && element.nodes.length > 0) {
          newArr = newArr.concat(this.flattenArrObj(element.nodes));
        }
      });
    }
    return newArr;
  }

  private checklistSaveObj(model, modifiedBy) {
    let listModel = new FeatureChecklistItemUpdate();
    listModel.title = model.item.checkList.title;
    listModel.score = model.item.checkList.scoreIndex;
    listModel.userId = BaseServices.UserId;
    listModel.parentItems = [];
    listModel.ModifiedBy = modifiedBy;
    if (model.item.checkList.sections.length > 0) {
      model.item.checkList.sections.forEach(ParentItem => {
        let section = this.checklistSecObj(ParentItem);
        listModel.parentItems.push(section);
      });
    }

    return listModel;
  }

  private checklistSecObj(obj) {
    let section = new ParentItem();
    section.parentItemId = obj.id; // Id
    section.parentId = 0;
    section.parentItemPoint = obj.position;
    section.parentItemTitle = obj.title;
    section.parentItemStatus = obj.status;
    section.childItems = this.checklistItemObj(obj.items);
    return section;
  }

  private checklistItemObj(objItem) {
    let items: ChildItem[] = [];
    if (isArray(objItem)) {
      objItem.forEach((item: any) => {
        items.push({
          childItemId: item.id,
          childItemTitle: item.title,
          childItemPoint: item.position,
          isView: item.status
        });
      });
    }
    return items;
  }

  /**
   * Method to show all files
   */
  showAllFiles() {
    if (this.treeNode) {
      this.isShowAllFile = false;
      let flattenned = this.flattenArrObj(this.treeNode);
      this.uploadedFiles = flattenned.filter(
        x => x.status === 1
      );
      let filteredFolder = this.treeNode.filter(x => x.isFolder === true);
      this.filteredFolderDetails = this.treeNode;
      if (filteredFolder) {
        this.folderToFilter = [];
        this.folderToFilter.push({
          label: this.translate.instant('SELECT'),
          value: null
        });
        filteredFolder.forEach(element => {
          this.folderToFilter.push({
            label: defaultFolderDisplayName(element, this.translate),
            value: element.nodeId
          });
        });
      }
    }
  }

  isUserRights(rightsId: number): boolean {
    return BaseServices.checkUserRights(+rightsId, BaseServices.UserRole);
  }

  /**
   * Method to extract node ids from the tree data
   * @param nodes - Array of TreeData objects
   * @returns Array of node ids
   */
  private extractNodeIds(nodes: TreeData[]): number[] {
    const nodeIds: number[] = [];
    nodes.forEach(node => {
      nodeIds.push(node.nodeId);
    });

    return nodeIds;
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sub, i) => {
      sub.unsubscribe();
    });
  }
}
